// Types
import mixins from "vue-typed-mixins"; // Mixins
import { WithRefs } from '../../utils/withRefs';

// Utils
import { animationFrameThrottle } from '../../utils/throttling';
const ControllerHeader = mixins(WithRefs()).extend({
  name: 'ControllerHeader',
  provide() {
    return {
      controllerHeader: this
    };
  },
  props: {
    tag: {
      type: String,
      default: 'header'
    }
  },
  data() {
    return {
      isMeasured: false,
      isStickied: false,
      topHeight: 0,
      activeItem: null,
      isLocaleChanged: false
    };
  },
  computed: {
    navigationItems() {
      return this.$components.storage.navigationItems;
    },
    availableLocales() {
      const locales = this.$i18n.locales;
      const normalisedLocales = locales === null || locales === void 0 ? void 0 : locales.map(locale => typeof locale === 'string' ? {
        code: locale
      } : locale);
      if (!normalisedLocales) return [];
      const localesWithoutCurrent = normalisedLocales.filter(locale => {
        return locale.code !== this.$i18n.locale;
      });
      return normalisedLocales || localesWithoutCurrent || [];
    }
  },
  async fetch() {
    if (this.navigationItems.length && !this.isLocaleChanged) return;
    await this.$components.fetchMainNavigation();
    if (process.browser) this.$display.recalculate();
    this.isLocaleChanged = false;
  },
  watch: {
    '$i18n.locale'() {
      this.isLocaleChanged = true;
      this.$fetch();
    }
  },
  async mounted() {
    await this.$nextTick();
    const {
      header
    } = this.$refs;
    if (header) {
      var _this$$refs$headerTop;
      this.$display.addToCalculation({
        top: header
      });
      this.isMeasured = true;
      this.topHeight = ((_this$$refs$headerTop = this.$refs.headerTop) === null || _this$$refs$headerTop === void 0 ? void 0 : _this$$refs$headerTop.getBoundingClientRect().height) || 0;
    }
    document.addEventListener('scroll', this.handleScroll, true);
    document.addEventListener('click', this.handleMouseClick, true);
    this.$nuxt.$on('page-mounted', () => {
      this.handleScroll();
      this.$display.recalculate();
    });
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.handleScroll, true);
    document.removeEventListener('click', this.handleMouseClick, true);
  },
  methods: {
    handleScroll: animationFrameThrottle(function () {
      const y = window.scrollY;
      this.isStickied = y > this.topHeight;
    }),
    handleMouseClick(e) {
      const x = e.clientX,
        y = e.clientY,
        elementUnderMouse = document.elementFromPoint(x, y);
      const shouldClosePanel = !(elementUnderMouse !== null && elementUnderMouse !== void 0 && elementUnderMouse.closest('.controller-navigation-bar')) && !(elementUnderMouse !== null && elementUnderMouse !== void 0 && elementUnderMouse.closest('#navigation-panel'));
      shouldClosePanel && this.setActiveItem(null);
    },
    setActiveItem(navigationItem) {
      this.activeItem = navigationItem;
    },
    async switchLanguage(code) {
      let pageData;
      const setPageData = data => pageData = data;
      this.$nuxt.$emit('getActivePageData', setPageData);
      if (pageData) {
        var _this$$application$la;
        // todo: make it a helper function
        // Convert two-letter lang code to three-letter
        const code3 = (_this$$application$la = this.$application.languages.find(language => language.code2 === code)) === null || _this$$application$la === void 0 ? void 0 : _this$$application$la.code;
        const postOrTermIdOptions = {};
        if (pageData['resourceType'] === 'term') {
          var _pageData;
          postOrTermIdOptions.termId = (_pageData = pageData) === null || _pageData === void 0 ? void 0 : _pageData['id'];
        } else {
          var _pageData2;
          postOrTermIdOptions.postId = (_pageData2 = pageData) === null || _pageData2 === void 0 ? void 0 : _pageData2['id'];
        }
        const res = await this.$api.cms.finder.getUrlOnLanguage({
          newLanguage: code3 || code,
          twoLetterCode: code,
          ...postOrTermIdOptions
        });
        if (res.errored) return;
        if (pageData['resourceType'] === 'term') {
          const urlParts = res.data.url.split('/');
          const slug = urlParts[1] || urlParts[0];
          const page = {
            name: this.$Page.Blog,
            params: {
              slug
            }
          };
          const path = this.localePath(page, code);
          await this.$router.push(path);
        } else {
          await this.$router.push(`/${res.data.url}`);
        }
      } else {
        this.$router.push(this.switchLocalePath(code));
      }
    }
  },
  render() {
    var _this$activeItem, _this$$scopedSlots$to, _this$$scopedSlots, _this$$scopedSlots$bo, _this$$scopedSlots2, _this$$scopedSlots$pa, _this$$scopedSlots3;
    const h = arguments[0];
    const topProps = {
      availableLocales: this.availableLocales,
      switchLanguage: this.switchLanguage
    };
    const bottomProps = {
      isStickied: this.isStickied,
      availableLocales: this.availableLocales,
      switchLanguage: this.switchLanguage
    };
    const panelProps = {
      items: ((_this$activeItem = this.activeItem) === null || _this$activeItem === void 0 ? void 0 : _this$activeItem.children) || [],
      close: () => this.setActiveItem(null)
    };
    const ContainerTag = this.tag;
    return h(ContainerTag, {
      "ref": "header",
      "class": ['controller-header', this.isMeasured ? 'absolute top-0 left-0 right-0' : '']
    }, [h("div", {
      "ref": "headerTop",
      "class": "controller-header-top"
    }, [(_this$$scopedSlots$to = (_this$$scopedSlots = this.$scopedSlots).top) === null || _this$$scopedSlots$to === void 0 ? void 0 : _this$$scopedSlots$to.call(_this$$scopedSlots, topProps)]), h("div", {
      "class": ['controller-header-bottom', this.isStickied ? 'fixed left-0 right-0 top-0' : '']
    }, [(_this$$scopedSlots$bo = (_this$$scopedSlots2 = this.$scopedSlots).bottom) === null || _this$$scopedSlots$bo === void 0 ? void 0 : _this$$scopedSlots$bo.call(_this$$scopedSlots2, bottomProps), this.activeItem && h("div", {
      "attrs": {
        "id": "navigation-panel"
      },
      "class": "controller-header-panel absolute left-0 right-0 flex",
      "style": "top: 100%"
    }, [(_this$$scopedSlots$pa = (_this$$scopedSlots3 = this.$scopedSlots).panel) === null || _this$$scopedSlots$pa === void 0 ? void 0 : _this$$scopedSlots$pa.call(_this$$scopedSlots3, panelProps)])])]);
  }
});
export default ControllerHeader;